import { z } from "zod";

/**
 * Delete Deployment Path Variables Schema
 */
export const DeleteDeploymentPathVarsSchema = z.object({
  id: z.string().uuid()
});

export type DeleteDeploymentPathVars = z.infer<typeof DeleteDeploymentPathVarsSchema>;
